module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "china-item"
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": _vm.chinaImg1,
      "title": "优选特推"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "china-content-1",
    style: ({
      background: ("url(" + _vm.china1Bg + ")")
    }),
    attrs: {
      "id": "qua-swiper"
    }
  }, [_c('div', {
    staticClass: "swipe",
    attrs: {
      "id": "qua-swiper-container"
    }
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('CarouselItem', {
      key: index
    }, _vm._l((item), function(child) {
      return _c('div', {
        staticClass: "qua-item",
        staticStyle: {
          "float0": "left"
        }
      }, [_c('router-link', {
        attrs: {
          "to": {
            path: '/goods',
            query: {
              goods_id: child.goodsId
            }
          }
        }
      }, [_c('img', {
        attrs: {
          "src": child.imgUrl,
          "alt": child.tip
        }
      })])], 1)
    }), 0)
  }), 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38bcaa84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/china-time-honored/optimization.vue
// module id = 1573
// module chunks = 1